export const typeSafeObjectKeys = (obj) => Object.keys(obj);
